import * as Animate from "react-reveal";

const steps = [
  {
    number: "01",
    title: "Choose your program",
    desc: "Find the pathway that matches your interests, experience and goals.",
  },
  {
    number: "02",
    title: "Learn by doing",
    desc: "Attend classes, complete exercises and work on practical projects.",
  },
  {
    number: "03",
    title: "Prove your capability",
    desc: "Complete assessments and build a portfolio of evidence.",
  },
  {
    number: "04",
    title: "Prepare for the workplace",
    desc:
      "Receive career coaching, interview preparation and professional support.",
  },
  {
    number: "05",
    title: "Join the Talent Network",
    desc:
      "Create a verified profile and access relevant opportunities when eligible.",
  },
];

const HomeJourneySection = () => {
  return (
    <section className="bg-white py-16 md:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="max-w-[900px] mb-12">
            <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
              <span className="w-8 h-[3px] bg-secondary inline-block"></span>
              The student journey
            </p>
            <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl mb-5">
              From choosing a skill to becoming opportunity-ready.
            </h2>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Learning comes first. Access to relevant opportunities follows
              capability, eligibility and availability—it is never presented as
              a guaranteed job.
            </p>
          </div>
        </Animate.Fade>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3.5">
          <div className="hidden lg:block absolute top-[29px] left-[5%] right-[5%] h-0.5 bg-hire-line" />
          {steps.map((step) => (
            <Animate.Fade bottom key={step.number}>
              <article className="relative z-[1] border border-hire-line bg-white rounded-[19px] min-h-[270px] px-4 pb-5">
                <span className="relative w-[58px] font-poppins h-[58px] border-[5px] border-white bg-secondary text-primary rounded-full grid place-items-center ring-1 ring-hire-line mx-auto -mt-px mb-14 text-sm font-extrabold">
                  {step.number}
                </span>
                <h3 className="text-primary text-lg mb-2 font-bold font-poppins">
                  {step.title}
                </h3>
                <p className="text-gray text-sm leading-[1.65] font-poppins m-0">
                  {step.desc}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeJourneySection;
